<template>
    <v-main>
        <v-container v-show="showParameters" fluid class="mt-3">
            <v-row dense no-gutters>
                <v-col cols="2" class="mx-2">
                    <v-text-field v-model="hpbzCode" label="Homeowner booking ID" 
                        ></v-text-field>
                </v-col>
                <v-col cols="2" class="mx-2">
                    <v-text-field v-model="huisCode" label="Accommodation ID" 
                        ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1">
                    <v-btn class="primary ma-0" small @click="getHpbz">Search</v-btn>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid>
            <v-btn v-show="!showParameters" class="primary ma-0" small @click="parametersShow()">Show parameters</v-btn>

            <div v-if="results">
                <v-card flat class="px-2">

                    <v-text-field v-model="search" label="Search in results" single-line hide-details prepend-icon="mdi-magnify">
                    </v-text-field>
                    <v-data-table :items="items" :headers="headers" :search="search" :disable-pagination=true
                        no-data-text="No bookings to display" :hide-default-footer="true" loading-text="Loading data...please wait" :loading="loading">
                        <template v-slot:item="props">
                            <tr>
                                <td @click="$router.open('/hpbz/onHpbz/' + props.item.hpbz_encrid + '/' + props.item.huis_encrid)" class="font-row"><a>
                                        {{ props.item.hpbz_code }} </a></td>
                                <td class="font-row"><v-chip small :color=props.item.hust_kleur><span class="chiptext">{{ props.item.hust_code }}</span></v-chip></td>
                                <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)" class="font-row"><a> {{ props.item.huis_code }} </a></td>
                                <td class="font-row">{{ $moment(props.item.hpbz_dt).format("DD-MMM-YYYY HH:mm") }}</td>
                                <td class="font-row">{{ props.item.hpbz_klnt_naam }}</td>
                                <td class="font-row">{{ $moment(props.item.hpbz_van_dat).format("DD-MMM-YYYY ddd") }}</td>
                                <td class="font-row">{{ $moment(props.item.hpbz_tm_dat).format("DD-MMM-YYYY ddd") }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </v-container>
        <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
    </v-main>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
export default {
    components: {
        navBar,
    },
    data() {
        return {
            results: false,
            showParameters: true,
            items: [],
            hpbzCode: '',
            huisCode: '',
            HpbzDatum: '',
            hulpDate: '',
            hpbzDatVan: '',
            hpbzDatTm: '',
            search: '',
            loading: false,
            headers: [
                { text: 'Id', value: 'hpbz_code' },
                { text: 'Status', value: 'hust_code' },
                { text: 'Accommodation', value: 'huis_code' },
                { text: 'Booking date', value: 'hpbz_dt' },
                { text: 'Customer name', value: 'hpbz_klnt_naam' },
                { text: 'Arrival date', value: 'hpbz_tm_dat' },
                { text: 'Departure date', value: 'hpbz_tm_dat' },
                { text: '', sortable: false, width: '7%' }
            ]
        }
    },
    methods: {
        updateData(data){
            this[data.field] = data.value;
        },
        parametersShow() {
            this.hpbzCode = '';
            this.huisCode = '';
            this.showParameters = true;
        },
        getHpbz() {
            this.results = true;
            this.showParameters = false;
            this.loading=true;
            this.$axios
                .post("ares/json/ares/hpbz/searchHpbz.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchHpbz"
                    },
                    searchHpbz: {
                        hpbz_code: this.hpbzCode,
                        huis_code: this.huisCode
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.loading = false;
                    } else {
                        this.items = res.data.searchHpbz;
                        this.loading = false;
                        console.log('hustcodes selected', this.hustCodesSelected);
                    }
                })
        }
    }
};

</script> 
<style scoped>
    .grid-item-error {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid red;
        color: red;
        cursor: default;
    }

    .grid-item-warning {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid orange;
        color: orange;
        cursor: default;
    }

    .grid-item-pending {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid blue;
        color: blue;
        cursor: default;
    }

    .grid-item-change {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid #FF8800;
        color: #FF8800;
        cursor: default;
    }

    .grid-item-ok {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid green;
        color: green;
        cursor: default;
    }

    .format-amount {
        text-align: end;
    }
    .font-row{
        font-size: smaller !important;
    }
    .flex{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .last-item {
        margin-left: auto;
    }
    .chiptext {
       color: black !important;
    }
</style>